module.exports = __webpack_public_path__ + "img/bonus_symbol_0.4467f0b3.png";